export default __webpack_public_path__ + "locales/sk/Settings.json?hash=c01f087e1fd5ca9cfd6dccf20db86d25";